import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  enabled: true,
  type: 'desk',
  externalId: null,

  geometry: () => ({
    type: 'Point',
    coordinates: faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
  }),

  asDesk: trait({
    type: 'desk',
    geometry: () => ({
      type: 'Point',
      coordinates: [
        faker.number.float({ min: 0, max: 0.5, precision: 0.0001 }),
        faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      ],
    }),
    afterCreate(feature, server) {
      if (!feature.externalId) {
        const floor = server.schema.floors.find(feature.mapFloor.id);
        const desk = server.create('desk', 'withNeighborhood', {
          floor,
          assignedTo: null,
          enabled: true,
        });
        feature.update({ externalId: desk.id, name: desk.name });
      }
    },
  }),

  asDeskWithAssignment: trait({
    type: 'desk',
    geometry: () => ({
      type: 'Point',
      coordinates: [
        faker.number.float({ min: 0, max: 0.5, precision: 0.0001 }),
        faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      ],
    }),
    afterCreate(feature, server) {
      if (!feature.externalId) {
        const floor = server.schema.floors.find(feature.mapFloor.id);
        const desk = server.create('desk', 'withAssignment', {
          floor,
          assignedTo: null,
          enabled: true,
        });
        // const gqlAssignment = server.create('graphql/assignment', { desk });
        // creating it as a desk-map-feature with an assigned employee to test side-panel interactions
        // server.create('graphql/desk-map-feature', 'asAssignedDesk', { desk });
        feature.update({ externalId: desk.id, name: desk.name });
      }
    },
  }),

  asAssignedDesk: trait({
    type: 'desk',
    geometry: () => ({
      type: 'Point',
      coordinates: [
        faker.number.float({ min: 0, max: 0.5, precision: 0.0001 }),
        faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      ],
    }),

    afterCreate(feature, server) {
      if (!feature.externalId) {
        const user = server.create('user', 'asEmployee');
        const floor = server.schema.floors.find(feature.mapFloor.id);
        const desk = server.create('desk', 'withNeighborhood', {
          floor,
          assignedTo: user.email,
          enabled: true,
        });
        feature.update({ externalId: desk.id, name: desk.name });
      }
    },
  }),

  asVisitorArea: trait({
    type: 'visitor-area',
    geometry: () => ({
      type: 'Point',
      coordinates: [
        faker.number.float({ min: 0, max: 0.5, precision: 0.0001 }),
        faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      ],
    }),
  }),

  asDeliveryArea: trait({
    type: 'delivery-area',
    geometry: () => ({
      type: 'Point',
      coordinates: [
        faker.number.float({ min: 0, max: 0.5, precision: 0.0001 }),
        faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      ],
    }),
  }),

  asRoom: trait({
    type: 'room',
    geometry: () => ({
      type: 'Polygon',
      coordinates: [
        [0.75, 0.1],
        [0.75, 0.25],
        [0.85, 0.25],
        [0.85, 0.1],
      ],
    }),
  }),
});
